/**
 * TODO STE-1606: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import React from "react";

import { css, cx } from "@emotion/css";
import { Link } from "@tanstack/react-router";

import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseLogoProps = {};

export type LogoStyleClasses = StyleClasses<"container" | "icon">;

export type LogoProps = AtomProps<BaseLogoProps, LogoStyleClasses>;

export const Logo: React.FC<LogoProps> = ({ id = "app-logo", className, classes }) => {
  const styles = useStyles(makeStyles);
  return (
    <Link to="/" id={id} className={cx(styles.container, className, classes?.container)}>
      <Icons.logoRoundFull className={cx(styles.img, classes?.icon)} />
    </Link>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: block;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  `,
  img: css`
    color: ${theme.palette.environment};
    width: ${theme.spacing(24)};
    height: ${theme.spacing(24)};
  `,
});
